import { useQuery } from '@apollo/client';
import { Column, Columns, Hidden } from 'braid-design-system';
import { Navigate, useSearchParams } from 'react-router-dom';

import CustomLoader from 'src/components/CustomLoader/CustomLoader';
import { Error } from 'src/components/Error/Error';
import { PaymentContainer } from 'src/components/PaymentContainer/PaymentContainer';
import Routes from 'src/config/routes';
import { GetListingProductsForPaymentPageDocument } from 'src/generated/graphql';
import { isNonNullable } from 'src/utils';

import HeroImage from './components/HeroImage/HeroImage';
import { SelectedProduct } from './components/SelectedProduct/SelectedProduct';

// TODO: need integration tests for this page (when does a user encounter this?)
export const PaymentConfirmPage = () => {
  const [searchParams] = useSearchParams();
  const { data, loading, error } = useQuery(
    GetListingProductsForPaymentPageDocument,
  );

  const productTokens = searchParams.getAll('productToken');
  const listingId = searchParams.get('listingId');

  if (loading) {
    return (
      <PaymentContainer width="medium">
        <CustomLoader />
      </PaymentContainer>
    );
  }

  if (!data || error) {
    return (
      <PaymentContainer width="medium">
        <Error />
      </PaymentContainer>
    );
  }

  const selectedProducts = productTokens
    .map((token) =>
      data.listingProducts.find(
        (product) => product.productToken.toLowerCase() === token.toLowerCase(),
      ),
    )
    .filter(isNonNullable);

  const firstProduct = selectedProducts.at(0);

  // We only support one product in the confirmation flow and it requires a listingId
  if (!firstProduct || selectedProducts.length > 1 || !listingId) {
    return <Navigate to={Routes.PACKAGES} />;
  }

  return (
    <PaymentContainer width="medium">
      <Columns space="medium" collapseBelow="tablet" alignY="center">
        <Column width="1/3">
          <SelectedProduct listingId={listingId} product={firstProduct} />
        </Column>

        <Hidden below="tablet">
          <Column>
            <HeroImage />
          </Column>
        </Hidden>
      </Columns>
    </PaymentContainer>
  );
};
